<style>
@import '../../custom/css/lista-dicas.css';

#contatos .limit-table::-webkit-scrollbar:vertical {
  display: none;
  min-height: 600px;
}
</style>

<template>
  <div id="contatos">
    <h1 class="title text-uppercase font-weight-bold mt-5">Lista de Contatos</h1>
    <hr class="linha-amarela" />
    <div class="limit-table">
      <table class="table w-1200px">
        <thead class="letter-orange">
            <th class="text-center">Nome</th>
            <th class="text-center">Whatsapp</th>
            <th class="text-center">Telefone</th>
            <th class="text-center">E-mail</th>
            <th class="text-center">Assunto</th>
            <th class="text-center">Mensagem</th>
            <th class="text-center">Criado em.</th>
        </thead>
        <tbody>
          <tr v-for="(showContact, index) in returnData" v-bind:key="index">
            <td class="text-center w-1200px">{{ showContact.name }}</td>
            <td class="text-center w-1200px">{{ showContact.phoneNumber }}</td>
            <td class="text-center w-1200px">{{ showContact.telephone }}</td>
            <td class="text-center w-1200px">{{ showContact.email }}</td>
            <td class="text-center w-1200px">{{ showContact.subject }}</td>
            <td class="text-center w-1200px">{{ showContact.message }}</td>
            <td class="text-center w-1200px">{{ showContact.created_at }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'contato-admin',
  data() {
    return {
        nome: [],
        whatsapp: null,
        criado_em: [],
        returnData: [],
        id: [],
    };
  },


  computed: {
    ...mapState(['token', 'dadosUsuario']),
    ...mapState({
      showContact: (state) => state.showContact,
    }),
  },

  created() {
    this.$store.dispatch('showContact')
  },

  watch: {
    'showContact': function () {
      this.catchContact();
    },

  },

  methods: {
    catchContact() {
      this.returnData = this.showContact
    },
  },
}
</script>
